import LegalLayout from '@/layouts/LegalLayout';

export default function Contact() {
  return (
    <LegalLayout title="Contact and grievances" updated="draft">
      <h2>Support</h2>
      <p>
        For anything about your account, a session, or a charge:
        <br />
        <strong>[SUPPORT EMAIL]</strong>
        <br />
        <strong>[SUPPORT PHONE]</strong>, <strong>[HOURS]</strong>
      </p>
      <p>
        We reply within <strong>48 hours</strong>. Refund requests are decided within{' '}
        <strong>7 working days</strong>.
      </p>

      <h2>Safety — report someone</h2>
      <p>
        If someone behaved inappropriately, use the <strong>Report</strong> option on the session or
        profile. That reaches the safety team directly and is faster than email.
      </p>
      <p>
        Reports involving a minor, a threat, or sexual conduct are treated as{' '}
        <strong>highest severity</strong> and the account is suspended pending review.
      </p>
      <p>
        <strong>
          If you or someone else is in immediate danger, contact the emergency services.
        </strong>{' '}
        We are not an emergency service and cannot respond in real time.
      </p>

      <h2>Grievance Officer</h2>
      <p>
        Appointed under the Information Technology (Intermediary Guidelines and Digital Media Ethics
        Code) Rules, 2021.
      </p>
      <p>
        <strong>Name:</strong> [GRIEVANCE OFFICER NAME]
        <br />
        <strong>Designation:</strong> [DESIGNATION]
        <br />
        <strong>Email:</strong> [GRIEVANCE EMAIL]
        <br />
        <strong>Address:</strong> [REGISTERED ADDRESS]
      </p>
      <p>
        The Grievance Officer acknowledges a complaint within <strong>24 hours</strong> and resolves
        it within <strong>15 days</strong> of receipt.
      </p>

      <h2>Data protection</h2>
      <p>
        To see, correct or delete the data we hold about you — see the{' '}
        <a href="/privacy">Privacy policy</a> — write to:
      </p>
      <p>
        <strong>[DPO NAME]</strong>
        <br />
        <strong>[DPO EMAIL]</strong>
      </p>
      <p>
        We respond within <strong>30 days</strong>.
      </p>

      <h2>Registered office</h2>
      <p>
        <strong>[LEGAL ENTITY NAME]</strong>
        <br />
        [ADDRESS LINE 1]
        <br />
        [ADDRESS LINE 2]
        <br />
        [CITY], [STATE] [PIN]
        <br />
        India
      </p>
      <p>
        <strong>CIN:</strong> [CIN] &nbsp;·&nbsp; <strong>GSTIN:</strong> [GSTIN]
      </p>

      <h2>For companions</h2>
      <p>
        Questions about verification, earnings or payouts:
        <br />
        <strong>[COMPANION SUPPORT EMAIL]</strong>
      </p>

      <p>
        <strong>[BEFORE LAUNCH]</strong> — every bracketed field above must be filled in. Razorpay
        checks this page during merchant activation, and the Grievance Officer details are a
        statutory requirement, not a formality.
      </p>
    </LegalLayout>
  );
}
